import React from 'react';

export default function NoInternetContent() {
  return (
    <div className="page-content">
      <div id="main-frame-error" className="interstitial-wrapper">
        <div id="main-content" jstcache="0">
          <div className="icon icon-offline" alt="">
          </div>
          <div id="main-message">
            <h1>
              <span>No internet</span>
            </h1>
            <div id="suggestions-list">
              <p>Try:</p>
              <ul>
                <li>Checking the network cables, modem, and router</li>
                <li>Reconnecting to Wi-Fi</li>
              </ul>
              <div className="error-code">ERR_INTERNET_DISCONNECTED</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
